import { RootDispatch } from "@store";
import {
  ActionAddMinerProfile,
  ActionDeleteMinerProfile,
  ActionEditMinerProfile,
  ActionMinerProfiles,
  ActionSetMinerProfiles,
} from "./actionTypes";

export const setMinerProfiles = (
  payload: ActionSetMinerProfiles["payload"]
): ActionSetMinerProfiles => {
  return {
    type: ActionMinerProfiles.SET_PROFILES,
    payload,
  };
};

export const deleteMinerProfile = (
  payload: ActionDeleteMinerProfile["payload"]
): ActionDeleteMinerProfile => {
  return {
    type: ActionMinerProfiles.DELETE_PROFILE,
    payload,
  };
};

export const editMinerProfile = (
  payload: ActionEditMinerProfile["payload"]
): ActionEditMinerProfile => {
  return {
    type: ActionMinerProfiles.EDIT_PROFILES,
    payload,
  };
};

export const addMinerProfile = (
  payload: ActionAddMinerProfile["payload"]
): ActionAddMinerProfile => {
  return {
    type: ActionMinerProfiles.ADD_PROFILE,
    payload,
  };
};
